"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
// eslint-disable-next-line import/extensions
const STLLoader_js_1 = require("three/examples/jsm/loaders/STLLoader.js");
const material_1 = require("../material");
// eslint-disable-next-line import/no-cycle
const Extrusion_model_3d_1 = __importDefault(require("../models/Extrusion.model.3d"));
// eslint-disable-next-line import/no-cycle
const Component_model_3d_1 = __importDefault(require("../models/Component.model.3d"));
// eslint-disable-next-line import/no-cycle
const utils_1 = require("../../../utils/utils");
class SLTLoaderHelper extends STLLoader_js_1.STLLoader {
    loadFile(item) {
        // temporary part:
        const color = (0, utils_1.getItemColor)(item);
        const path = (0, utils_1.formatAssetsURL)(item.meshFile.url);
        const partType = item.itemType.name;
        const extrusionMaterial = color ? (0, material_1.DarkMetalBaseMaterial)(color) : (0, material_1.MetalBaseMaterial)();
        // end of temporary part
        return new Promise((resolve, reject) => {
            this.load(path, (geometry) => {
                const material = extrusionMaterial;
                const mesh = new THREE.Mesh(geometry, material);
                mesh.castShadow = true;
                mesh.receiveShadow = true;
                let part = null;
                if (partType === 'Extrusion') {
                    part = new Extrusion_model_3d_1.default();
                }
                else if (partType === 'Component') {
                    part = new Component_model_3d_1.default(item.componentAlignInfo);
                }
                part.add(mesh);
                resolve(part);
            });
        });
    }
}
exports.default = SLTLoaderHelper;
